import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_116: FaireProductEntity = {
  token: "starter_collection_116",
  type: "product",
  name: "Beachwood Bulk Bag (5lb)",
  brandName: "Canyon Coffee",
  imageUrl:
    "https://cdn.faire.com/fastly/a71c1ee188800d106eff86f58e9239e969d712b0ec833670855ffcb089aad60d.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=1440&width=1440",
  priceDollars: 85,
  msrpDollars: 170,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
